import { Select } from "@silversea-ssc/ui-components-react";
import React from "react";
import { connectSortBy } from "react-instantsearch-dom";

const SortBy = ({ items, currentRefinement, refine }) => {
  return (
    <Select
      variant="transparent"
      style={{ maxWidth: "60vw" }}
      value={currentRefinement}
      onChange={(event) => {
        event.preventDefault();
        refine(event.target.value);
      }}
      data-content-piece="sort-by-interaction"
    >
      {items.map((i) => (
        <option key={i.value} value={i.value} disabled={i.disabled}>
          {i.label}
        </option>
      ))}
    </Select>
  );
};

export default connectSortBy(SortBy);
